import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import {
    deleteAccount,
} from "./queries";

const accountApi = createApi({
    reducerPath: "accountApi",
    baseQuery: fetchBaseQuery({
        baseUrl: adminBaseUrl,
        prepareHeaders: headerWithAuthToken,
    }),
    endpoints: (builder) => ({
        // delete user account
        deleteAccount: builder.mutation({
            invalidatesTags: ["account"],
            query: deleteAccount,
        }),
    }),
});

export const {
    useDeleteAccountMutation,
    reducer: accountApiReducer,
    reducerPath: accountApiReducerPath,
    middleware: accountApiMiddleWare,
} = accountApi;
